import {Container} from "../../../styles/components";
import {FormattedMessage} from "react-intl";
import * as S from './styles'

import Phone from "../../../assets/images/dwl_phone.png";

export const ApkDownload = () => {
    return (
        <Container>
            <S.Content>
                <S.Title><FormattedMessage id="downloadApkTitle1"/></S.Title>
                <S.Text><FormattedMessage id="downloadApkText1"/></S.Text>
                <S.Text><FormattedMessage id="downloadApkText2"/></S.Text>
                <S.Text><FormattedMessage id="downloadApkText3"/></S.Text>
                <S.Title><FormattedMessage id="downloadApkTitle2"/></S.Title>
            </S.Content>
            <S.Content2>
                <S.Image src={Phone}/>
                <div>
                    <S.DownloadButton><FormattedMessage id="downloadApkButton1"/></S.DownloadButton>
                    <S.HelpButton><FormattedMessage id="downloadApkButton2"/></S.HelpButton>
                </div>
            </S.Content2>
        </Container>
    );
}